export const GetTimestamp00Hours = (timestamp: number): number => {
  const date: Date = new Date(
    `${new Date(+timestamp).getMonth() + 1}/${new Date(+timestamp).getDate()}/${new Date(+timestamp).getFullYear()}`,
  );
  const offset: number = date.getTimezoneOffset() * 60 * 1000;
  return date.getTime() - offset;
};

export const GetTimezoneOffset = (): number => {
  function z(n) {
    return (n < 10 ? '0' : '') + n;
  }
  let offset = new Date().getTimezoneOffset();
  const sign = offset < 0 ? '+' : '-';
  offset = Math.abs(offset);
  const res = sign + z((offset / 60) | 0) + z(offset % 60);
  return +res / 100;
};

export const FormatStripDate = stripDate => {
  return `${stripDate.substr(0, 2)}/${stripDate.substr(2, 2)}/${stripDate.substr(4, 4)}`;
};
export const HasMore18 = (date: string) => {
  // dd/mm/yyyy
  const [day, month, year] = date.split('/');
  const minDate = new Date(`${month}/${day}/${+year + 18}`);
  return Date.now() > minDate.getTime();
};
